<template>
    <div class="card shadow-sm mb-4">
        <div class="card-body px-3 pt-lg-5 px-3 px-lg-4">
            <div class="d-flex flex-row align-items-start ">
                <img src="../../assets/images/person.svg" alt="" class="mr-3" style="width: 29px">
                <h3>Contact Address</h3>
            </div>
            <div v-if="edit">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <label for="subBuildingNumberName">Sub-building number/name</label>
                            <input type="text" id="subBuildingNumberName" v-model.trim="$v.subBuildingNumberName.$model"
                                   class="form-control form-control-lg"
                                   :class="{'is-invalid' : $v.subBuildingNumberName.$error}">
                        </div>
                    
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <label for="buildingNumberName">Building number/name</label>
                            <input type="text" id="buildingNumberName" v-model.trim="$v.buildingNumberName.$model"
                                   class="form-control form-control-lg"
                                   :class="{'is-invalid' : $v.buildingNumberName.$error}">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <label for="streetAddress">Street address</label>
                            <input type="text" id="streetAddress" v-model.trim="$v.streetAddress.$model"
                                   class="form-control form-control-lg"
                                   :class="{'is-invalid' : $v.streetAddress.$error}">
                            <div class="invalid-feedback" v-if="!$v.streetAddress.required">
                                Please enter street address!
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <label for="postCode">Post code</label>
                            <input type="text" id="postCode" v-model.trim="$v.postCode.$model"
                                   class="form-control form-control-lg" :class="{'is-invalid' : $v.postCode.$error}">
                            <div class="invalid-feedback" v-if="!$v.postCode.required">
                                Please enter post code!
                            </div>
                            <div class="invalid-feedback" v-if="!$v.postCode.validPostCode">
                                Please enter a valid post code!
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <button class="btn btn-lg btn-success btn-success-gradient float-right" @click="updateAddress" :disabled="running">
                            Update address
                        </button>
                        <button class="btn btn-lg btn-outline-info float-right mr-4" @click="edit = false">Cancel
                        </button>
                    </div>
                </div>
            
            </div>
            <div v-else>
                <div class="row" v-if="contactAddress">
                    <div class="col">
                        <div>{{ contactAddressFormatted }}</div>
                    </div>
                </div>
                <div class="row" v-if="propertyAddress">
                    <div class="col">
                        <div>{{ propertyAddress }}</div>
                        <small class="text-muted">
                            Your switching address
                        </small>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <button class="btn btn-lg btn-success btn-success-gradient float-right" @click="edit = true" >
                            Update address
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/utils/api";
import {validationMixin} from 'vuelidate'
import {required} from "vuelidate/lib/validators";

const postCodeRegex = new RegExp('([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\\s?[0-9][A-Za-z]{2})')
const validPostCode = (value) => postCodeRegex.test(value)
export default {
    name: "ContactAddress",
    mixins: [validationMixin],
    data() {
        return {
            contactAddress: null,
            propertyAddress: null,
            edit: false,
            running: false,
            subBuildingNumberName: null,
            buildingNumberName: null,
            streetAddress: null,
            postCode: null,
        }
    },
    validations: {
        subBuildingNumberName: {},
        buildingNumberName: {},
        streetAddress: {
            required
        },
        postCode: {
            required,
            validPostCode
        },
    },
    computed: {
        contactAddressFormatted: function () {
            return Object.values(this.contactAddress).filter(v => !!v).join(', ')
        }
    },
    methods: {
        updateAddress: function () {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return
            }
            this.running = true
            
            let that = this;
            
            api.updateAddress({
                postcode: this.postCode,
                streetAddress: this.streetAddress,
                buildingNumberName: this.buildingNumberName,
                subBuildingNumberName: this.subBuildingNumberName,
            }).then(() => {
                api.profile().then(response => {
                    that.contactAddress = response.data.data.contact_address
                    that.edit = false
                    that.running = false
                    that.propertyAddress = null
                });
            })
        }
    },
    mounted() {
        let that = this;
        api.profile().then(response => {
            if (!response.data.data.contact_address) {
                api.properties().then(response => {
                    let properties = response.data.data;
                    if (properties.length) {
                        that.propertyAddress = properties[0].currentPropertyAddress
                    }
                })
            } else {
                that.contactAddress = response.data.data.contact_address
            }
        });
        
    }
}
</script>

<style scoped>

</style>
